// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3fUKq","choiceBoxes":"toolbarselects_choiceBoxes__3QKkx","simpleField":"toolbarselects_simpleField__3ip1h"};